// src/components/Store.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, CardGroup } from 'react-bootstrap';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";

import { gsap } from 'gsap';
import StoreNav from './StoreNav';
import "./Store.scss"
import styles from "./ImageGrid2.module.css"
import { motion } from "framer-motion";
import { GoHeart } from "react-icons/go";
import { GoHeartFill } from "react-icons/go";

import { BiSolidCartDownload } from "react-icons/bi";

// import { getDownloadURL} from 'firebase/storage';
import AddToCart from "../images/icons/add-to-cart-icon-2.png";
import StoreImgSkeleton from './skeletons/StoreImgSkeleton';
import CartModal from "./CartModal.js"
import DownloadModal from './DownloadModal';
import WelcomeAssets from './WelcomeAssets.js';
import MeteFooter from './MeteFooter.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from "react-ga4";

//firestore and paystack imports
import { firestore } from '../Firebase/Firebase';
import { collection, onSnapshot, arrayUnion, increment } from 'firebase/firestore';
import { auth } from '../Firebase/Firebase';
import { onAuthStateChanged } from 'firebase/auth'
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { getStorage, ref, getMetadata } from 'firebase/storage';
import PayWithPaystack from '../hooks/PayWithPaystack.js';
import usePaystackCartPayment from '../hooks/usePaystackCartPayment.js';

import { useHistory } from 'react-router-dom';


import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong. Please try again later.</h1>;
    }

    return this.props.children;
  }
}
const Store = () => {



  useEffect(() => {
    document.title = "Store | mete & design."; // or whatever is appropriate
  }, []);


  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [uniqueLabels, setUniqueLabels] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const [likedAssets, setLikedAssets] = useState({}); // State to track liked assets
  const [likeCounts, setLikeCounts] = useState({});
  const [user, setUser] = useState(null);
  const [showCart, setShowCart] = useState(false); // State to control cart modal
  const postsPerPageWithImages = 6;
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [loadingText, setLoadingText] = useState('Beep Bop Boop'); // Initial loading text
  const [dotCount, setDotCount] = useState(0); // Count of dots to display
  const [showDownload, setShowDownload] = useState(false); // State to control download modal visibility
  const [downloadFiles, setDownloadFiles] = useState([]); // State to hold files for download

  const [cartItems, setCartItems] = useState([]); // State to track cart items
  const [filteredAssets, setFilteredAssets] = useState([]);


  const totalPrice = cartItems.reduce((total, item) => {
    // Remove currency symbol and commas, then convert to a number
    const price = parseFloat(item.price.toString().replace(/₦|,/g, '').trim());
    return total + (isNaN(price) ? 0 : price); // Add to total, ensuring it's a number
  }, 0);

  ReactGA.set({ user_id: user });



  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.to(".App", { duration: .0, css: { visibility: 'visible' } });
    });
    return () => {
      ctx.revert();
    }
  }, []);


  useEffect(() => {
    const fetchCartItems = async () => {

      if (user) {
        const userRef = doc(firestore, 'users', user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          setCartItems(userDoc.data().cartItems || []); // Fetch cart items from Firestore
        }
      }
    };

    fetchCartItems();
  }, [user]);


  const addToCart = async (asset) => {
    // Check if the asset is already in the cart
    const isAssetInCart = cartItems.some(item => item.id === asset.id);
    if (isAssetInCart) {
      notifyUnSuccess(); // Notify the user
      return; // Exit the function if the asset is already in the cart
    }
    const updatedCartItems = [...cartItems, asset]; // Add the new asset to the cart

    // Update Firestore
    if (user) {
      const userRef = doc(firestore, 'users', user.uid);
      await updateDoc(userRef, {
        cartItems: updatedCartItems // Update the cartItems field
      });
    }

    setCartItems(updatedCartItems); // Update local state
    notifySuccess();
  };

  const removeFromCart = async (itemId) => {
    const updatedCartItems = cartItems.filter(item => item.id !== itemId); // Remove the item from the cart

    // Update Firestore
    if (user) {
      const userRef = doc(firestore, 'users', user.uid);
      await updateDoc(userRef, {
        cartItems: updatedCartItems // Update the cartItems field
      });
    }

    setCartItems(updatedCartItems); // Update local state
  };
  const handleShowCart = () => setShowCart(true);
  const handleCloseCart = () => setShowCart(false);



  const notifySuccess = () => {
    toast.success('Asset added to Cart!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  const notifyUnSuccess = () => {
    toast.error('This asset is already in Cart!', {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user); // Set the authenticated user
    });

    return () => unsubscribe(); // Cleanup the listener on unmount
  }, []);

  const getFileType = (url) => {
    // Extract the file extension from the URL
    const extensionMatch = url.match(/\.([a-zA-Z0-9]+)(\?.*)?$/);
    const extension = extensionMatch ? extensionMatch[1].toLowerCase() : '';

    switch (extension) {
      case 'pdf':
        return 'PDF Document';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'Image';
      case 'mp3':
        return 'Audio';
      case 'mp4':
        return 'Video';
      case 'zip':
        return 'ZIP Archive';
      case 'psd':
        return 'PSD';
      case 'blend':
        return 'BLEND';
      case 'blend1':
        return 'BLEND';
      case 'prproj':
        return 'Premiere Pro';
      case 'aep':
        return 'After Effects';
      case 'abr':
        return 'Photoshop Brush';
      // Add more cases as needed
      default:
        return 'Unknown File Type';
    }
  };


  // Convert bytes to a readable format
  const formatFileSize = (bytes) => {
    if (bytes === null) return 'N/A';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  };

  useEffect(() => {
    const fetchAssets = async () => {
      const assetsCollection = collection(firestore, 'Assets');
      const unsubscribe = onSnapshot(assetsCollection, async (snapshot) => {
        const assetsList = await Promise.all(
          snapshot.docs.map(async (doc) => {
            const data = { id: doc.id, ...doc.data() };

            // Get the file type based on the asset URL
            data.fileType = getFileType(data.asset);

            setLikeCounts(prev => ({ ...prev, [data.id]: data.likes || 0 }));

            // Get file size from Firebase Storage
            const storage = getStorage();
            const assetRef = ref(storage, data.asset);  // Assuming `data.asset` is the path in Firebase Storage

            try {
              const metadata = await getMetadata(assetRef);
              data.fileSize = metadata.size; // File size in bytes
            } catch (error) {
              console.error("Error fetching file metadata:", error);
              data.fileSize = null; // If there's an error fetching the file size, set it to null
            }

            return data;
          })
        );

        setAssets(assetsList);
        setFilteredAssets(assetsList);

        // Extract unique categories
        const originalLabels = Array.from(new Set(
          assetsList.map(doc => doc.category).filter(Boolean)
        ));

        // Prepare display labels mapping
        const displayLabels = originalLabels.map(label => ({
          original: label,
          display: label.endsWith('s') ? label : `${label}s`
        }));

        setUniqueLabels(displayLabels);
        setLoading(false); // Set loading to false after fetching

        // Track purchase event when assets are fetched
        trackAssetsForAnalytics(assetsList);
      }, (error) => {
        console.error("Error fetching assets:", error);
        setError(error.message);
        setLoading(false); // Set loading to false on error
      });

      return () => unsubscribe(); // Cleanup the listener on unmount
    };

    fetchAssets();
  }, []);

  const trackAssetsForAnalytics = (assetsList) => {
    ReactGA.event("view_item_list", {
      item_list_name: "All Assets", // <-- This should show up in GA
      items: assetsList.map((asset) => ({
        item_name: asset.name,
        item_id: asset.id,
        price: asset.price || 0,
        category: asset.category || "Uncategorized",
      })),
    });
  };

  const handleTabClick = (tab) => {

    let filtered;

    switch (tab) {
      case 'free':
        filtered = assets.filter(asset => asset.price === "free");
        break;
      case '1000-10000':
        filtered = assets.filter(asset => {
          const price = parseInt(asset.price, 10);
          return price >= 1000 && price <= 10000;
        });
        break;
      case '20000-30000':
        filtered = assets.filter(asset => {
          const price = parseInt(asset.price, 10);
          return price >= 20000 && price <= 30000;
        });
        break;
      case '30000+':
        filtered = assets.filter(asset => {
          const price = parseInt(asset.price, 10);
          return price >= 30000;
        });
        break;
      default:
        filtered = assets; // Show all assets
        break;
    }

    setFilteredAssets(filtered);
    setActiveTab(tab);
  };


  const handleImageLoad = () => {
    setImagesLoaded(prev => prev + 1); // Increment loaded images count
  };

  // Check if all images are loaded
  const allImagesLoaded = imagesLoaded === assets.length;


  const getDocumentCountByLabel = (displayLabel) => {
    const mapping = uniqueLabels.find(item => item.display === displayLabel);
    if (!mapping) return 0; // If mapping is missing, return 0
    const originalLabel = mapping.original;
    return assets.filter(asset => asset.category === originalLabel).length;
  };

  const handlePurchaseClick = (asset) => {
    setSelectedAsset(asset);
    setShowModal(true);

  };


  //
  //
  //Payments
  //
  //
  //

  // Count the number of free assets
  const freeAssetCount = assets.filter(asset => asset.price === "free").length;

  // let purchaseTracked = false;

  const trackPurchase = (transactionId, items, totalValue) => {
    if (sessionStorage.getItem("purchaseTracked_" + transactionId)) return;
    sessionStorage.setItem("purchaseTracked_" + transactionId, "true");


    ReactGA.event("purchase", {
      transaction_id: transactionId,
      value: parseFloat(totalValue),
      currency: "NGN",
      items: items.map((item) => ({
        item_name: item.name,
        item_id: item.id,
        price: parseFloat(item.price),
        quantity: item.quantity || 1,
        category: item.category || "Uncategorized",
      })),
    });
  };



  const [hasPaid, setHasPaid] = useState(false);


  useEffect(() => {
    if (hasPaid && selectedAsset) {
      const expiresAt = Date.now() + 2 * 60 * 60 * 1000; // 2 hours
      localStorage.setItem(
        `paidAsset_${selectedAsset.id}`,
        JSON.stringify({ paid: true, expiresAt })
      );
    }
  }, [hasPaid, selectedAsset]);



  // Function to save purchase history to the database
  const savePurchaseHistory = async (purchaseData) => {
    try {
      const userRef = doc(firestore, "users", purchaseData.userId); // Reference to the user document
      await updateDoc(userRef, {
        purchaseHistory: arrayUnion(purchaseData), // Add purchase data to the user's purchase history
      });
    } catch (error) {
      console.error("Error saving purchase history:", error);
    }
  };

  useEffect(() => {
    if (selectedAsset) {
      const stored = localStorage.getItem(`paidAsset_${selectedAsset.id}`);
      if (stored) {
        const { paid, expiresAt } = JSON.parse(stored);
        if (paid && Date.now() < expiresAt) {
          setHasPaid(true);
        } else {
          localStorage.removeItem(`paidAsset_${selectedAsset.id}`);
          setHasPaid(false);
        }
      }
    }
  }, [selectedAsset]);

  const { handleCartPayment } = usePaystackCartPayment({
    email: user?.email,
    userId: user?.uid,
    cartItems,
    onSuccess: () => {
      setCartItems([]);
      setDownloadFiles(cartItems);
      setShowDownload(true);
      handleCloseCart();
      trackPurchase(cartItems);
      savePurchaseHistory(cartItems);
    },
    onClose: () => {
      console.log("Payment popup closed");
    }
  });






  const trackFreeDownload = (assetData) => {
    ReactGA.event("free_download", {
      item_name: assetData.name,
      item_id: assetData.id,
      category: assetData.category || "Uncategorized",
      action: "Download",
    });
  };




  const handleDownload = async (assetId) => {
    console.log("Asset ID:", assetId); // Log the asset ID
    if (typeof assetId !== 'string') {
      console.error("Invalid asset ID:", assetId); // Log an error if assetId is not a string
      return;
    }

    const assetRef = doc(firestore, 'Assets', assetId); // Reference to the asset document

    try {
      // Get the asset details
      const assetDoc = await getDoc(assetRef);
      if (assetDoc.exists()) {
        const assetData = assetDoc.data();

        // Create purchase data for the free asset
        const purchaseData = {
          id: assetId, // Use the asset ID as the purchase ID
          itemName: assetData.name,
          date: new Date().toISOString(),
          amount: "Free", // Indicate that it's free
          userId: user.uid, // Assuming you have user ID
          thumbnail: assetData.thumbnail,
          downloadUrl: assetData.asset, // Assuming you have the download URL
        };

        // Save purchase history for the free asset
        await savePurchaseHistory(purchaseData);

        // Track free download in Google Analytics
        trackFreeDownload({ ...assetData, id: assetId, itemName: assetData.name });

        // Increment the download count in Firestore
        await updateDoc(assetRef, {
          downloads: increment(1) // Increment the download count by 1
        });

        // Trigger the actual download (this part depends on your implementation)
        window.location.href = assetData.asset; // Redirect to the download URL
      } else {
        console.error("No valid asset selected for download.");
      }
    } catch (error) {
      console.error("Error updating downloads:", error);
    }
  };



  const handleCloseModal = () => {
    setShowModal(false);
    // setIsPurchased(false);
    setSelectedAsset(null);
  };




  const toggleLike = async (assetId) => {
    if (!user) {
      alert("You must be logged in to like an asset.");
      return;
    }

    const isLiked = likedAssets[assetId] || false; // Check if the asset is already liked
    const assetRef = doc(firestore, 'Assets', assetId); // Reference to the asset document
    const userRef = doc(firestore, 'users', user.uid); // Reference to the user document

    // Optimistically update the local state
    setLikedAssets(prevLikedAssets => ({
      ...prevLikedAssets,
      [assetId]: !isLiked // Toggle the liked status
    }));

    try {
      // Get the current document to check the likes and likedUsers fields
      const assetDoc = await getDoc(assetRef);
      const currentLikes = assetDoc.exists() ? assetDoc.data().likes || 0 : 0;
      const currentLikedUsers = assetDoc.exists() ? assetDoc.data().likedUsers || [] : [];

      // Update the asset's like count
      await updateDoc(assetRef, {
        likes: isLiked ? currentLikes - 1 : currentLikes + 1, // Increment or decrement likes
        likedUsers: isLiked
          ? currentLikedUsers.filter(name => name !== user.displayName) // Remove displayName if unliking
          : [...currentLikedUsers, user.displayName] // Add displayName if liking
      });

      // Update the user's liked assets
      const userDoc = await getDoc(userRef);
      const userLikedAssets = userDoc.exists() ? userDoc.data().likedAssets || [] : [];

      if (isLiked) {
        // If already liked, remove from user's liked assets
        await updateDoc(userRef, {
          likedAssets: userLikedAssets.filter(id => id !== assetId) // Remove assetId from likedAssets
        });
      } else {
        // If not liked, add to user's liked assets
        await updateDoc(userRef, {
          likedAssets: [...userLikedAssets, assetId] // Add assetId to likedAssets
        });
      }
    } catch (error) {
      console.error("Error updating likes:", error);
      // If there's an error, revert the optimistic update
      setLikedAssets(prevLikedAssets => ({
        ...prevLikedAssets,
        [assetId]: isLiked // Revert to previous state
      }));
    }
  };

  useEffect(() => {
    if (user) {
      const fetchLikedAssets = async () => {
        const userRef = doc(firestore, 'users', user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const likedAssets = userDoc.data().likedAssets || [];
          setLikedAssets(prev => {
            const updatedLikes = {};
            likedAssets.forEach(assetId => {
              updatedLikes[assetId] = true; // Mark liked assets as true
            });
            return { ...prev, ...updatedLikes };
          });
        }
      };

      fetchLikedAssets();
    }
  }, [user]);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null); // Clear user state on logout
      console.log("Logged out successfully!");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };



  useEffect(() => {
    // Simulate loading process
    const loadingTimer = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4); // Cycle through 0 to 3
    }, 200); // Update every second

    // Cleanup function to clear the interval
    return () => clearInterval(loadingTimer);
  }, []);

  // Update loading text based on dotCount
  useEffect(() => {
    if (loading) {
      setLoadingText('Beep Bop Boop' + '.'.repeat(dotCount)); // Add dots based on dotCount
    }
  }, [dotCount, loading]);

  // Simulate loading completion after 5 seconds for demonstration
  useEffect(() => {
    const loadingCompleteTimer = setTimeout(() => {
      setLoading(false); // Set loading to false after 5 seconds
    }, 5000); // Change this duration as needed

    return () => clearTimeout(loadingCompleteTimer);
  }, []);


  const count1000To10000 = assets.filter(asset => {
    const price = parseInt(asset.price, 10);
    return price >= 1000 && price <= 10000;
  }).length;
  const count20000To30000 = assets.filter(asset => {
    const price = parseInt(asset.price, 10);
    return price >= 20000 && price <= 30000;
  }).length;
  const count30000Plus = assets.filter(asset => {
    const price = parseInt(asset.price, 10);
    return price >= 30000;
  }).length;
  const History = useHistory();


  if (loading) return <div className='center'><p className='center-text'>{loadingText}</p></div>;
  if (error) return <p>Error fetching assets: {error}</p>;



  return (
    <div className="allAsset">
      <ErrorBoundary>
        <StoreNav onLogout={handleLogout} user={user} cartItems={cartItems} handleShowCart={handleShowCart} totalPrice={totalPrice} />
      </ErrorBoundary>
      <CartModal
        show={showCart}
        onClose={handleCloseCart}
        cartItems={cartItems}
        totalPrice={totalPrice}
        onCartPayment={handleCartPayment}
        onRemoveFromCart={removeFromCart} // Pass the remove function to the modal
      />

      <DownloadModal
        show={showDownload}
        onClose={() => setShowDownload(false)}
        files={downloadFiles} // Pass the files for download
      />
      <Container className='store-up'>

        {user ? (
          <>

            <section className={styles['cutscene']}>

            </section>
            <ToastContainer className="toastContainer" />
            <div className={styles["portfo"]}>
              <Tabs value={activeTab} className={styles['tabiu_store']} >
                <TabsHeader
                  className={styles['tabHeader']}


                >
                  <Tab
                    title={`All (${assets.length})`}
                    value="all"
                    onClick={() => handleTabClick('all')}
                    className={`${styles['filters']} ${activeTab === 'all' ? styles.activeTab : ''}`}
                  >
                    <span> All</span>
                    <span className={styles['count']}>{assets.length}</span>
                  </Tab>
                  <Tab
                    value="free"
                    onClick={() => handleTabClick('free')}
                    className={`${styles['filters']} ${activeTab === 'free' ? styles.activeTab : ''}`}
                  >
                    <span>Free</span>
                    <span className={styles['count']}>{freeAssetCount}</span>
                  </Tab>
                  <Tab
                    value="1000-10000"
                    onClick={() => handleTabClick('1000-10000')}
                    className={`${styles['filters']} ${activeTab === '1000-10000' ? styles.activeTab : ''}`}
                  >
                    <span>₦1,000 - ₦10,000</span>
                    <span className={styles['count']}>{count1000To10000}</span>
                  </Tab>
                  <Tab
                    value="20000-30000"
                    onClick={() => handleTabClick('20000-30000')}
                    className={`${styles['filters']} ${activeTab === '20000-30000' ? styles.activeTab : ''}`}
                  >
                    <span>₦20,000 - ₦30,000</span>
                    <span className={styles['count']}>{count20000To30000}</span>
                  </Tab>
                  <Tab
                    value="30000+"
                    onClick={() => handleTabClick('30000+')}
                    className={`${styles['filters']} ${activeTab === '30000+' ? styles.activeTab : ''}`}
                  >
                    <span>₦30,000+</span>
                    <span className={styles['count']}>{count30000Plus}</span>
                  </Tab>

                  {uniqueLabels.map(({ display }) => (
                    <Tab
                      title={`${display} (${getDocumentCountByLabel(display)})`}
                      key={display}
                      value={display}
                      onClick={() => handleTabClick(display)}
                      className={`${styles['filters']} ${activeTab === display ? styles.activeTab : ''}`}
                    >
                      <span>{display}</span>
                      <span className={styles['count']}>{getDocumentCountByLabel(display)}</span>
                    </Tab>
                  ))}
                </TabsHeader>

                <TabsBody
                  animate={{
                    initial: { y: 250 },
                    mount: { y: 0 },
                    unmount: { y: 250 },
                  }}
                  className={styles['tabsBod']}
                >
                  {loading || allImagesLoaded ? (
                    <TabPanel value="all">
                      <Row xs={1} md={3} xl={3}>
                        {[...Array(postsPerPageWithImages)].map((_, index) => (
                          <Col key={`skeleton_${index}`} className='col-sm'>
                            <StoreImgSkeleton />
                          </Col>
                        ))}
                      </Row>
                    </TabPanel>
                  ) : (
                    <TabPanel value="all" className={styles['surround_store']} >
                      <Container className='fluidContain' fluid>



                        {filteredAssets.length > 0 ? (
                          filteredAssets.map((asset, index) => (

                            <div className={styles["packs"]} key={asset.id || index}>
                              <Row className='assety'>
                                <Col >

                                  <CardGroup className="card-wrapper">

                                    <motion.div

                                      className={'assetCard'}

                                      whileHover={{ top: "-10px", scale: 1.01 }}
                                      transition={{ type: "tween", stiffness: 300 }}
                                      layout
                                    >

                                      {asset.category === 'Video Template' ? (
                                        <>
                                          <div className="cart-placement">
                                            {asset.price !== "free" && (
                                              <img
                                                src={AddToCart}
                                                alt="Add to Cart"
                                                className='cart-add'
                                                onClick={() => addToCart(asset)}
                                              />
                                            )}

                                            <video width="100%" height="auto" autoPlay loop muted playsInline loading='lazy' poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                              <source src={asset.thumbnail} type={'video/mp4'} />
                                              Your browser does not support the video tag.
                                            </video>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="cart-placement">
                                            {asset.price !== "free" && (
                                              <img
                                                src={AddToCart}
                                                alt="Add to Cart"
                                                className='cart-add'
                                                onClick={() => addToCart(asset)}
                                              />
                                            )}
                                            <div className="placeholder" id='placeholder'></div>



                                            <motion.div
                                              whileHover={{ filter: "saturate(0)" }}
                                              className={styles['imgWrapper']} // optional extra styling
                                            >
                                              <LazyLoadImage
                                                variant="top" src={asset.thumbnail}
                                                alt="Thumbnail"
                                                className='imageImg'
                                                onClick={() => History.push(`/store/${asset.id}`)}
                                                style={{
                                                  width: loading ? '400px' : '100%',
                                                  height: loading ? '300px' : '100%',
                                                  display: loading ? 'block' : 'flex', // Hide the image while loading
                                                  objectFit: 'cover', // Adjust as needed
                                                }}
                                                onLoad={handleImageLoad}

                                                effect="blur" // adds blur effect while loading
                                              />
                                            </motion.div>
                                          </div>
                                        </>
                                      )}
                                      <Card.Body className='assetCardBody' >
                                        <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                        <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>

                                        <div className="line"><div className="line-inner"></div></div>
                                        <div className="bottom-area">
                                          <Button
                                            variant="primary"
                                            className='learnBtn'
                                            onClick={() => {
                                              if (asset.price === "free") {
                                                setSelectedAsset(asset); // Set selected asset
                                                setShowModal(true); // Show modal for free assets
                                              } else {
                                                handlePurchaseClick(asset); // Open modal for paid assets
                                              }
                                            }}
                                          >
                                            {asset.price === "free" ? "Download" : "Purchase"}
                                          </Button>

                                          <div className="downs">


                                            <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                            <div className="likes">

                                              {likedAssets[asset.id] ? (
                                                <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                  <GoHeartFill className='heart-here' />
                                                </div>
                                              ) : (
                                                <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                  <GoHeart className='heart-here' />
                                                </div>
                                              )}
                                              {/* Display Like Count */}
                                              <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                                {likeCounts[asset.id] || 0}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </Card.Body>

                                    </motion.div>
                                  </CardGroup>
                                </Col>
                              </Row>
                            </div>

                          ))
                        ) : (
                          <p>No assets available.</p>
                        )}


                      </Container>
                    </TabPanel>
                  )}
                  {uniqueLabels.map(({ original, display }) => (
                    <TabPanel key={original} value={display} className={styles['surround']}>
                      <Container>
                        {filteredAssets.filter(doc => doc.category === original).map((asset, index) => (
                          <div className={styles["packs"]} key={asset.id || index}>
                            <Row className='assety'>
                              <Col>
                                <CardGroup className={styles["cardhi"]}>
                                  <motion.div

                                    className={'assetCard'}
                                    whileHover={{ top: "-10px", scale: 1.01 }}
                                    layout
                                  >
                                    {asset.category === 'Video Template' ? (
                                      <>
                                        <div className="cart-placement">
                                          {asset.price !== "free" && (
                                            <img
                                              src={AddToCart}
                                              alt="Add to Cart"
                                              className='cart-add'
                                              onClick={() => addToCart(asset)}
                                            />
                                          )}

                                          <video width="100%" height="auto" autoPlay loop muted playsInline loading='lazy' poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                            <source src={asset.thumbnail} type={'video/mp4'} />
                                            Your browser does not support the video tag.
                                          </video>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="cart-placement">
                                          {asset.price !== "free" && (
                                            <img
                                              src={AddToCart}
                                              alt="Add to Cart"
                                              className='cart-add'
                                              onClick={() => addToCart(asset)}
                                            />
                                          )}

                                          <Card.Img variant="top" src={asset.thumbnail}
                                            alt="Thumbnail"
                                            className='imageImg'
                                            onLoad={handleImageLoad}
                                            onClick={() => History.push(`/store/${asset.id}`)}
                                          />

                                        </div>
                                      </>
                                    )}
                                    <Card.Body className='assetCardBody'>
                                      <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                      <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                      <div className="line"><div className="line-inner"></div></div>
                                      <div className="bottom-area">
                                        <Button
                                          variant="primary"
                                          className='learnBtn'
                                          onClick={() => {
                                            if (asset.price === "free") {
                                              setSelectedAsset(asset); // Set selected asset
                                              setShowModal(true); // Show modal for free assets
                                            } else {
                                              handlePurchaseClick(asset); // Open modal for paid assets
                                            }
                                          }}
                                        >
                                          {asset.price === "free" ? "Download" : "Purchase"}
                                        </Button>

                                        <div className="downs">
                                          <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                          <div className="likes">

                                            {likedAssets[asset.id] ? (
                                              <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                <GoHeartFill className='heart-here' />
                                              </div>
                                            ) : (
                                              <div className="heart" onClick={() => toggleLike(asset.id)}>
                                                <GoHeart className='heart-here' />
                                              </div>
                                            )}
                                            {/* Display Like Count */}
                                            <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                              {likeCounts[asset.id] || 0}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Body>
                                  </motion.div>
                                </CardGroup>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </Container>
                    </TabPanel>
                  ))}

                  <TabPanel value="free" className={styles['surround']}>
                    <Container>
                      {filteredAssets.filter(asset => asset.price === "free").map((asset) => (
                        <div className={styles["packs"]} key={asset.id}>
                          <Row className='assety'>
                            <Col>
                              <CardGroup className={styles["cardhi"]}>
                                <motion.div

                                  className={'assetCard'}
                                  whileHover={{ top: "-10px", scale: 1.01 }}
                                  layout
                                >
                                  {asset.category === 'Video Template' ? (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                            loading="lazy"
                                          />
                                        )}

                                        <video width="100%" height="auto" playsInline autoPlay loop muted loading="lazy" poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                          <source src={asset.thumbnail} type={'video/mp4'} />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <Card.Img variant="top" src={asset.thumbnail}
                                          alt="Thumbnail"
                                          className='imageImg'
                                          onLoad={handleImageLoad}
                                          onClick={() => History.push(`/store/${asset.id}`)}
                                        />

                                      </div>
                                    </>
                                  )}
                                  <Card.Body className='assetCardBody'>
                                    <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                    <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                    <div className="line"><div className="line-inner"></div></div>
                                    <div className="bottom-area">
                                      <Button
                                        variant="primary"
                                        className='learnBtn'
                                        onClick={() => {
                                          if (asset.price === "free") {
                                            setSelectedAsset(asset); // Set selected asset
                                            setShowModal(true); // Show modal for free assets
                                          } else {
                                            handlePurchaseClick(asset); // Open modal for paid assets
                                          }
                                        }}
                                      >
                                        {asset.price === "free" ? "Download" : "Purchase"}
                                      </Button>

                                      <div className="downs">
                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                        <div className="likes">

                                          {likedAssets[asset.id] ? (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeartFill className='heart-here' />
                                            </div>
                                          ) : (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeart className='heart-here' />
                                            </div>
                                          )}
                                          {/* Display Like Count */}
                                          <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                            {likeCounts[asset.id] || 0}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </motion.div>
                              </CardGroup>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Container>
                  </TabPanel>
                  <TabPanel value="1000-10000" className={styles['surround']}>
                    <Container>
                      {filteredAssets.filter(asset => {
                        const price = parseInt(asset.price, 10);
                        return price >= 1000 && price <= 10000;
                      }).map((asset) => (
                        <div className={styles["packs"]} key={asset.id}>
                          <Row className='assety'>
                            <Col>
                              <CardGroup className={styles["cardhi"]}>
                                <motion.div

                                  className={'assetCard'}
                                  whileHover={{ top: "-10px", scale: 1.01 }}
                                  layout
                                >
                                  {asset.category === 'Video Template' ? (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <video width="100%" height="auto" autoPlay loop muted playsInline loading='lazy' poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                          <source src={asset.thumbnail} type={'video/mp4'} />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <Card.Img variant="top" src={asset.thumbnail}
                                          alt="Thumbnail"
                                          className='imageImg'
                                          onLoad={handleImageLoad}
                                          onClick={() => History.push(`/store/${asset.id}`)} />

                                      </div>
                                    </>
                                  )}
                                  <Card.Body className='assetCardBody'>
                                    <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                    <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                    <div className="line"><div className="line-inner"></div></div>
                                    <div className="bottom-area">
                                      <Button
                                        variant="primary"
                                        className='learnBtn'
                                        onClick={() => {
                                          if (asset.price === "free") {
                                            setSelectedAsset(asset); // Set selected asset
                                            setShowModal(true); // Show modal for free assets
                                          } else {
                                            handlePurchaseClick(asset); // Open modal for paid assets
                                          }
                                        }}
                                      >
                                        {asset.price === "free" ? "Download" : "Purchase"}
                                      </Button>

                                      <div className="downs">
                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                        <div className="likes">

                                          {likedAssets[asset.id] ? (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeartFill className='heart-here' />
                                            </div>
                                          ) : (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeart className='heart-here' />
                                            </div>
                                          )}
                                          {/* Display Like Count */}
                                          <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                            {likeCounts[asset.id] || 0}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </motion.div>
                              </CardGroup>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Container>
                  </TabPanel>

                  <TabPanel value="20000-30000" className={styles['surround']}>
                    <Container>
                      {filteredAssets.filter(asset => {
                        const price = parseInt(asset.price, 10);
                        return price >= 20000 && price <= 30000;
                      }).map((asset) => (
                        <div className={styles["packs"]} key={asset.id}>
                          <Row className='assety'>
                            <Col>
                              <CardGroup className={styles["cardhi"]}>
                                <motion.div

                                  className={'assetCard'}
                                  whileHover={{ top: "-10px", scale: 1.01 }}
                                  layout
                                >
                                  {asset.category === 'Video Template' ? (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <video width="100%" height="auto" autoPlay loop muted playsInline loading='lazy' poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                          <source src={asset.thumbnail} type={'video/mp4'} />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <Card.Img variant="top" src={asset.thumbnail}
                                          alt="Thumbnail"
                                          className='imageImg'
                                          onLoad={handleImageLoad}
                                          onClick={() => History.push(`/store/${asset.id}`)}
                                        />
                                      </div>
                                    </>
                                  )}
                                  <Card.Body className='assetCardBody'>
                                    <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                    <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                    <div className="line"><div className="line-inner"></div></div>
                                    <div className="bottom-area">
                                      <Button
                                        variant="primary"
                                        className='learnBtn'
                                        onClick={() => {
                                          if (asset.price === "free") {
                                            setSelectedAsset(asset); // Set selected asset
                                            setShowModal(true); // Show modal for free assets
                                          } else {
                                            handlePurchaseClick(asset); // Open modal for paid assets
                                          }
                                        }}
                                      >
                                        {asset.price === "free" ? "Download" : "Purchase"}
                                      </Button>

                                      <div className="downs">
                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                        <div className="likes">

                                          {likedAssets[asset.id] ? (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeartFill className='heart-here' />
                                            </div>
                                          ) : (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeart className='heart-here' />
                                            </div>
                                          )}
                                          {/* Display Like Count */}
                                          <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                            {likeCounts[asset.id] || 0}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </motion.div>
                              </CardGroup>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Container>
                  </TabPanel>

                  <TabPanel value="30000+" className={styles['surround']}>
                    <Container>
                      {filteredAssets.filter(asset => {
                        const price = parseInt(asset.price, 10);
                        return price >= 30000;
                      }).map((asset) => (
                        <div className={styles["packs"]} key={asset.id}>
                          <Row className='assety'>
                            <Col>
                              <CardGroup className={styles["cardhi"]}>
                                <motion.div

                                  className={'assetCard'}
                                  whileHover={{ top: "-10px", scale: 1.01 }}
                                  layout
                                >
                                  {asset.category === 'Video Template' ? (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <video width="100%" height="auto" autoPlay loop muted playsInline loading='lazy' poster={asset.thumbnail} className='imageImg' onClick={() => History.push(`/store/${asset.id}`)}>
                                          <source src={asset.thumbnail} type={'video/mp4'} />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="cart-placement">
                                        {asset.price !== "free" && (
                                          <img
                                            src={AddToCart}
                                            alt="Add to Cart"
                                            className='cart-add'
                                            onClick={() => addToCart(asset)}
                                          />
                                        )}

                                        <Card.Img variant="top" src={asset.thumbnail}
                                          alt="Thumbnail"
                                          className='imageImg'
                                          onLoad={handleImageLoad}
                                          onClick={() => History.push(`/store/${asset.id}`)}
                                        />
                                      </div>
                                    </>
                                  )}
                                  <Card.Body className='assetCardBody'>
                                    <Card.Title className='assetCardHead'>{asset.name}</Card.Title>
                                    <Card.Text className='assetCardText'>Price: {asset.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(asset.price)}`}</Card.Text>
                                    <div className="line"><div className="line-inner"></div></div>
                                    <div className="bottom-area">
                                      <Button
                                        variant="primary"
                                        className='learnBtn'
                                        onClick={() => {
                                          if (asset.price === "free") {
                                            setSelectedAsset(asset); // Set selected asset
                                            setShowModal(true); // Show modal for free assets
                                          } else {
                                            handlePurchaseClick(asset); // Open modal for paid assets
                                          }
                                        }}
                                      >
                                        {asset.price === "free" ? "Download" : "Purchase"}
                                      </Button>

                                      <div className="downs">
                                        <p className='carty'><BiSolidCartDownload className='heart-here' /> <strong>{asset.downloads || 0}</strong></p>


                                        <div className="likes">

                                          {likedAssets[asset.id] ? (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeartFill className='heart-here' />
                                            </div>
                                          ) : (
                                            <div className="heart" onClick={() => toggleLike(asset.id)}>
                                              <GoHeart className='heart-here' />
                                            </div>
                                          )}
                                          {/* Display Like Count */}
                                          <p style={{ color: likedAssets[asset.id] ? '#F0F0F0' : '#121212' }} className='numb-like' onClick={() => toggleLike(asset.id)}>
                                            {likeCounts[asset.id] || 0}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                </motion.div>
                              </CardGroup>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </Container>
                  </TabPanel>


                </TabsBody>
              </Tabs>
            </div>

            {/* Modal for Purchase Confirmation */}
            <Modal show={showModal} onHide={handleCloseModal} className='purch-mod' centered>
              <Modal.Header closeButton>
                <Modal.Title>Purchase Asset</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5>{selectedAsset?.name}</h5>
                <p>{selectedAsset?.fileType} </p>
                <p>Price: <strong>{selectedAsset?.price === "free" ? "Free" : `₦${new Intl.NumberFormat("en-NG").format(selectedAsset?.price)}`}</strong></p>
                {selectedAsset?.fileSize && (
                  <p>File Size: <strong>{formatFileSize(selectedAsset.fileSize)}</strong></p>  // Use a helper function to format the size
                )}
                {selectedAsset?.price !== "free" && (
                  <>
                    <p>Click the button below to proceed with the payment.</p>
                    <a
                      href={selectedAsset?.licenseLink}
                      rel="noreferrer"
                      target="_blank"
                      className="license"
                    >
                      {selectedAsset?.licenseText}
                    </a>
                  </>
                )}

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" className='redBtn' onClick={handleCloseModal}>
                  Close
                </Button>
                {selectedAsset?.price === "free" || hasPaid ? (
                  <Button variant="primary" className='learnBtn' onClick={() => handleDownload(selectedAsset.id)}>
                    Download Asset
                  </Button>
                ) : (
                  <PayWithPaystack
                    user={user}
                    selectedAsset={selectedAsset}
                    setHasPaid={setHasPaid}
                    setShowModal={setShowModal}
                  />
                )}
              </Modal.Footer>
            </Modal>
          </>
        ) : (
          <div className="allAsset">
            <WelcomeAssets />
          </div>
        )}
        <MeteFooter />
      </Container>

    </div>
  );
};

export default Store;